import { useState, useEffect } from 'react';
import { LoginPage } from './auth/LoginPage';
import { DesktopLoginPage } from './desktop/DesktopLoginPage';

export function ResponsiveLoginPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <LoginPage /> : <DesktopLoginPage />;
}